<template>
<el-upload
  class="upload-demo"
  ref="upload"
  :auto-upload="false"
>
  <template #trigger>
    <el-button size="small" type="primary">select file</el-button>
  </template>
  <el-button
    style="margin-left: 10px;"
    size="small"
    type="success"
    @click="submitpdfUpload"
    >upload to server</el-button
  >
  <template #tip>
    <div class="el-upload__tip">
      PDF file
    </div>
  </template>
</el-upload>
</template>

<script>
import AuthService from "@/api/auth.service";
import ListingsService from "@/api/listings.service";

  export default {
    methods: {
      submitpdfUpload() {
        //this.$refs.upload.submit()
		return ListingsService.uploadpdf(this.upload).then(response => {
                // this.data = response.data
				console.log(response.data.data)
                return response
              });
      },
    },
  }
</script>

<style>

</style>
